import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPGiroActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Giro/GiroBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPGiro"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPGiro"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPGiroActivity)
